import util from './util';

export default (config, slot, slotBidderCfg) => {
	const {
		targetingFields = [],
		...params
	} = util.getParamsFromConfig(config, slotBidderCfg);

	params.inventory = util.getTargeting(slot, targetingFields);

	return {
		'bidder': 'rubicon',
		params
	};
};
